var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
// O BottomNav é fixo (5rem): o respiro inferior evita que ele cubra os últimos itens.
// O respiro superior separa o primeiro card da header (antes era a barra de abas que fazia isso).
export var FileLibraryContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 16px 14px calc(5rem + 16px);\n"], ["\n  padding: 16px 14px calc(5rem + 16px);\n"])));
var templateObject_1;
